import { render, staticRenderFns } from "./LocalIdBox.vue?vue&type=template&id=2db22a7e&"
import script from "./LocalIdBox.vue?vue&type=script&lang=js&"
export * from "./LocalIdBox.vue?vue&type=script&lang=js&"
import style0 from "./LocalIdBox.vue?vue&type=style&index=0&id=2db22a7e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports